<template>
  <div class="base-control base-text form-group" :class="{row: inline, 'error': hasErrors, 'ok': isOk, disabled: disabled }">
    <label :for="id" class="col-sm-4" :class="{'col-form-label': inline}">{{ label }} <slot name="label"></slot></label>
    <div class="col-sm-8" :class="{'position-relative': inline}">
      <input ref="input" :id="id" class="form-control simple"
             :class="{[radius]: true, 'is-invalid': hasErrors}"
             :type="type" :value="value" @input="onInput($event)"
             :readonly="readonly" :disabled="disabled"
             v-input-mask :data-inputmask-mask="mask != '' ? mask : null" :data-inputmask-regex="maskRegex != '' ? maskRegex : null"
      />
      <span v-if="units && units.units" class="units">
        <a href="javascript:;" v-for="unit in units.units" @click="unitChange(unit)" :key="unit" :class="{selected: unit == units.source}">{{ unit }}</a>
      </span>
      <div class="invalid-feedback d-inline-block" :class="{'absolute-right-errors': (hasErrors && inline && !errorsNextLine)}" v-if="err && err.length > 0">
        <p class="error mb-0" v-for="error in err" :key="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseText',
  inject: ['$validator'],
  props: {
    value: [String, Number],
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    err: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    radius: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    units: {
      type: Object,
      default: () => {}
    },
    errorsNextLine: {
      type: Boolean,
      default: false
    },
    mask: {
      type: String,
      default: ''
    },
    maskRegex: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  $_veeValidate: {
    value () {
      return this.$refs.input.value;
    },
    name () {
      return this.name;
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value);
    },
    unitChange (unit) {
      this.$emit('input-unit', unit);
    }
  },
  data () {
    return {

    };
  },
  mounted () {
    if (this.value !== null && this.value !== '') {
      this.$validator.validateAll();
    }
    if (this.focus) {
      this.$refs['input'].focus();
    }
  },
  computed: {
    id () {
      return 'base-text-' + this._uid;
    },
    hasErrors () {
      return this.err && this.err.length > 0;
    },
    isOk() {
      let k = '';
      for (const key in this.fields) {
        k = key;
      }

      if (!this.fields[k] || !this.fields[k][this.name]) return false;
      return this.fields[k][this.name].validated && this.fields[k][this.name].valid;
    }
  },
};

</script>

<style>

</style>
